// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "li[data-v-472d54e0]::marker{color:#2eac68}", ""]);
// Exports
module.exports = exports;
